"use client";
import React from "react";
import { useNavigate } from "react-router-dom";
import StatsCard from "../../../../../components/stats-card";
import Navbar from "../../../../../components/navbar";
import Footer from "../../../../../components/footer";
import styles from "../css/collection_or_delivery.module.css";

const statsData = [
  { title: "Collections", icon: "calendar-check-2" },
  { title: "Delivery", icon: "truck" },
];

export function CollectionAndDeliveryMenu() {
  const navigate = useNavigate();

  const handleCardClick = (title) => {
    if (title === "Collections") {
      navigate("/dispensary/collection-and-delivery/collection-details");
    }

    if (title === "Delivery") {
      navigate("/dispensary/collection-and-delivery/delivery-details");
    }
  };

  return (
    <div className={styles.container}>
      <Navbar />
      <main className={styles.main}>
        <h1 className={styles.title}>Collection and Delivery</h1>
        <div className={styles.grid}>
          {statsData.map((stat, index) => (
            <StatsCard
              key={index}
              title={stat.title}
              icon={stat.icon}
              variant="square"
              onClick={() => handleCardClick(stat.title)}
            />
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default CollectionAndDeliveryMenu;
